import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CoordinatesInCanadianBorderRegionRequest } from './models/coordinates-in-canadian-border-region-request';
import { CoordinatesInCanadianBorderRegionResponse } from './models/coordinates-in-canadian-border-region-response';
import { ApiRouteConstants } from '../../constants/api-routes';

@Injectable({
    providedIn: 'root',
})
export class ToolsService {
    private readonly baseUrl = ApiRouteConstants.Tools.rootUrl;

    constructor(private readonly http: HttpClient) {}

    coordinatesInCanadianBorderRegion(
        request: CoordinatesInCanadianBorderRegionRequest,
    ): Observable<CoordinatesInCanadianBorderRegionResponse> {
        return this.http.post<CoordinatesInCanadianBorderRegionResponse>(
            `${this.baseUrl}/coordinates-in-canadian-border-region`,
            request,
        );
    }
}
